import MaterialsAccordion from "./MaterialsAccordion";

export default MaterialsAccordion